// @flow
import env from '../../../environment';
import {
  getCreator,
  postCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  GET_LEGAL_SETTING: `${env.baseApiUrl}/ui/admin/store/policies-settings`,
  GET_STORE_TERMS_CONFIG: `${env.baseApiUrl}/ui/admin/store/terms-of-service-information`,
  GET_STORE_SHIPPINGS_CONFIG: `${env.baseApiUrl}/ui/admin/store/shipping-information`,
  GET_STORE_ABOUT_US_CONFIG: `${env.baseApiUrl}/ui/admin/store/about-information`,
  GET_STORE_FAQ_CONFIG: `${env.baseApiUrl}/ui/admin/store/faq-information`,
  EDIT_STORE_FAQ_CONFIG: `${env.baseApiUrl}/ui/admin/store/faq-information/:faqId`,
  GET_STORE_REFUNDS_CONFIG: `${env.baseApiUrl}/ui/admin/store/refund-information`,
  STORE_POLICIES_AND_PRIVACY_CONFIG: `${env.baseApiUrl}/ui/admin/store/policies-and-privacy`,
});

export type SaveLegalRequest = {
  enabled?: boolean,
  description?: string,
  title?: string,
  description1?: string,
  description2?: string,
  description3?: string,
  image1?: string,
  image2?: string,
  image3?: string,
  image4?: string,
  image5?: string,
  image6?: string,
  arrFilledFile?: any[],
};

export const getStoreLegalSettingApi = getCreator(endpoints.GET_LEGAL_SETTING);
export const saveStoreLegalSettingApi = postCreator(
  endpoints.GET_LEGAL_SETTING
);
export const getStoreTermsConfigApi = getCreator(
  endpoints.GET_STORE_TERMS_CONFIG
);
export const saveStoreTermsConfigApi = postCreator(
  endpoints.GET_STORE_TERMS_CONFIG
);
export const getStoreShippingsConfigApi = getCreator(
  endpoints.GET_STORE_SHIPPINGS_CONFIG
);
export const saveStoreShippingsConfigApi = postCreator(
  endpoints.GET_STORE_SHIPPINGS_CONFIG
);
export const getStoreAboutUsConfigApi = getCreator(
  endpoints.GET_STORE_ABOUT_US_CONFIG
);
export const saveStoreAboutUsConfigApi = postCreator(
  endpoints.GET_STORE_ABOUT_US_CONFIG
);
export const getStoreFaqConfigApi = getCreator(endpoints.GET_STORE_FAQ_CONFIG);
export const editStoreFaqConfigApi = putCreator(
  endpoints.EDIT_STORE_FAQ_CONFIG
);
export const deleteStoreFaqConfigApi = deleteCreator(
  endpoints.EDIT_STORE_FAQ_CONFIG
);
export const saveStoreFaqConfigApi = postCreator(
  endpoints.GET_STORE_FAQ_CONFIG
);
export const getStoreRefundsConfigApi = getCreator(
  endpoints.GET_STORE_REFUNDS_CONFIG
);
export const saveStoreRefundsConfigApi = postCreator(
  endpoints.GET_STORE_REFUNDS_CONFIG
);

export const getStorePoliciesAndPrivacyConfigApi = getCreator(
  endpoints.STORE_POLICIES_AND_PRIVACY_CONFIG
);

export const saveStorePoliciesAndPrivacyConfigApi = postCreator(
  endpoints.STORE_POLICIES_AND_PRIVACY_CONFIG
);
